import {
  UserManager,
  WebStorageStateStore,
  User,
  UserManagerSettings,
} from "oidc-client-ts";
import { config } from "@/lib/config";

const getStorage = (): Storage => {
  try {
    localStorage.setItem("test", "test");
    localStorage.removeItem("test");
    return localStorage;
  } catch {
    return sessionStorage;
  }
};

export class AuthService {
  private userManager: UserManager;

  constructor() {
    const authConfig: UserManagerSettings = {
      authority: `${config.VITE_IDENTITY_API_URL}/`,
      client_id: "rentinit-admin",
      redirect_uri: `${window.location.origin}/callback`,
      post_logout_redirect_uri: `${window.location.origin}/logout-callback`,
      response_type: "code",
      scope:
        "openid profile rentinit-api-scope rentinit-admin-scope rentinit-profile offline_access",
      stateStore: new WebStorageStateStore({ store: getStorage() }),
      userStore: new WebStorageStateStore({ store: getStorage() }),
      automaticSilentRenew: true,
    };
    this.userManager = new UserManager(authConfig);
  }

  public async isAuthenticated(): Promise<boolean> {
    const user = await this.userManager.getUser();
    return user !== null && !user.expired;
  }

  public async getUser(): Promise<User | null> {
    return await this.userManager.getUser();
  }

  public async refreshUser(): Promise<void> {
    await this.userManager.signinSilent();
  }

  public async login(returnUrl: string): Promise<void> {
    await this.userManager.signinRedirect({
      state: {
        from: returnUrl,
      },
    });
  }

  public async completeLogin(): Promise<User> {
    return await this.userManager.signinRedirectCallback();
  }

  public async logout(): Promise<void> {
    await this.userManager.signoutRedirect();
  }

  public async completeLogout(): Promise<void> {
    await this.userManager.signoutRedirectCallback();
  }

  public async getAccessToken(): Promise<string | null> {
    const user = await this.getUser();

    if (!user) return null;

    return user.access_token;
  }
}

export const authService = new AuthService();
